import { captureErrorContext, buildPrefill } from '../../errorReportCapture';
import { setPendingErrorReport } from './errorReportSlice';
import { showToast } from './toastSlice';
const errorReportMiddleware = store => next => action => {
  const result = next(action);
  if (process.env.PUBLIC_URL === '/uk' && action.type === 'alert/handleError' && action.payload?.http_status >= 500) {
    store.dispatch(showToast({
      message: 'Something went wrong.',
      variant: 'danger',
      reportable: true
    }));
    captureErrorContext({
      error: action.payload,
      source: 'api'
    }).then(_ref => {
      let {
        context,
        screenshotFile
      } = _ref;
      store.dispatch(setPendingErrorReport({
        screenshotFile,
        prefill: buildPrefill(context)
      }));
    });
  }
  return result;
};
export default errorReportMiddleware;